import { useEffect } from 'react'
import BottomSheetContent from './BottomSheetContent'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../constants'
import Remark from '../ui-components/Remark'
import { useNavigate } from 'react-router-dom'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  ScreenName: string
}

export const OutOfFormAlert = ({ onDismiss, ScreenName }: BottomSheetWrapperPropTypes) => {
  const heading = 'Out-of-form Alert'
  const navigate = useNavigate()
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent
      logoSrc={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/alert-triangle-bottom-sheet.svg`}
      heading={heading}
      onDismiss={onDismiss}
    >
      <div className='flex flex-col gap-6'>
        <div className='text-[#6A6E6E] text-[14px] font-[400] leading-[150%]'>
          This fund has been consistently underperforming compared to other funds in its category, with poor ranks and
          difficulty in beating its benchmarks.
          <br />
          <br />
          We advise switching to a better performing fund. It will meaningfully boost long-term wealth growth.
        </div>
        <div onClick={() => navigate('/power-of-rebalancing')}>
          <Remark
            titleComponent={
              <span className='underline text-[#004D99] text-[13px] font-[500]'>Checkout Power of Rebalancing</span>
            }
          >
            <div>
              Active rebalancing (reinvesting in better performing funds) will significantly boost the wealth generated
              in the long run.
            </div>
          </Remark>
        </div>
      </div>
    </BottomSheetContent>
  )
}
